var _path, _rect, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _path3, _rect76, _path4, _rect77, _rect78, _rect79, _rect80;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubeRackLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 31,
    viewBox: "0 0 308 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 27H24V29H0L4 27Z",
    fill: "#99DFF9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 27,
    width: 8,
    height: 1,
    fill: "#668BA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 2H19V3H6V4H1V2Z",
    fill: "#008BBF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    fill: "#00AEEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 1,
    height: 25,
    fill: "#00AEEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 29,
    width: 24,
    height: 2,
    fill: "#00AEEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 134,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 226,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 27,
    width: 26,
    height: 2,
    fill: "#99DFF9"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 266,
    y: 27,
    width: 10,
    height: 1,
    fill: "#668BA6"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 2,
    width: 14,
    height: 1,
    fill: "#008BBF"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 2,
    width: 6,
    height: 2,
    fill: "#008BBF"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 29,
    width: 26,
    height: 2,
    fill: "#00AEEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M304 27H284V29H308L304 27Z",
    fill: "#99DFF9"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 1,
    transform: "matrix(-1 0 0 1 300 27)",
    fill: "#668BA6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M307 2H289V3H302V4H307V2Z",
    fill: "#008BBF"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    transform: "matrix(-1 0 0 1 308 0)",
    fill: "#00AEEF"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 2,
    transform: "matrix(-1 0 0 1 290 2)",
    fill: "#008BBF"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 25,
    transform: "matrix(-1 0 0 1 304 3)",
    fill: "#00AEEF"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 2,
    transform: "matrix(-1 0 0 1 308 29)",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeRackLarge);
export default __webpack_public_path__ + "static/media/tube_rack_large.b001206b90fd8e4ee87f2fd95ceca893.svg";
export { ForwardRef as ReactComponent };